<template>
  <div class="ws-chip-list">
    <div
      class="ws-chip-list__title"
      v-if="title"
    >
      {{title}}
    </div>
    <div
      class="ws-chip-list__list"
      :class="{'ml-3':title}"
    >
      <v-chip
        v-for="(chip,chipIndex) in chipList"
        :key="chipIndex"
        close
        class="ma-1 ws-chip-list__list-item"
        :color="backgroundColor"
        :text-color="textColor"
        :style="{ border:borderColor ? `1px solid ${borderColor}` : `none`}"
        @click:close="$_chipClose(chip)"
      >
        {{chip.text}}
      </v-chip>
    </div>
  </div>
</template>
<script>
export default {
  name: "WsChipList",
  props: {
    title: {
      type: String,
      default: "",
    },
    textColor: {
      type: String,
      default: "",
    },
    borderColor: {
      type: String,
      default: "",
    },
    backgroundColor: {
      type: String,
      default: "",
    },
    chipList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_chipClose(chip) {
      this.$emit("chip-close", chip);
    },
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-chip-list";
</style>